import { configureStore } from "@reduxjs/toolkit";
import citiesReducer from "./Slices/Citiesreducer";
import systemUserReducer from "./Slices/Systemuserreducer";

export const store = configureStore({
  reducer: {
    cities: citiesReducer,
    isSystemUser: systemUserReducer,
  },
});
